import { atom } from 'jotai';

export const ublProgressAtom = atom<{
  active: boolean;
  errors?: any;
  value?: number;
}>({
  active: false,
});
